// React Query keys. Every key is scoped by account id so workspaces never share cache.
export const keys = {
  users: (a: string) => ['users', a] as const,
  user: (a: string, id: string) => ['user', a, id] as const,
  team: (a: string) => ['team', a] as const,
  org: (a: string, team: string) => ['org', a, team] as const,
  conversations: (a: string) => ['conversations', a] as const,
  conversation: (a: string, id: string) => ['conversation', a, id] as const,
  publicChannels: (a: string, archived: boolean) => ['publicChannels', a, archived] as const,
  history: (a: string, channel: string) => ['history', a, channel] as const,
  replies: (a: string, channel: string, ts: string) => ['replies', a, channel, ts] as const,
  members: (a: string, channel: string) => ['members', a, channel] as const,
  pins: (a: string, channel: string) => ['pins', a, channel] as const,
  bookmarks: (a: string, channel: string) => ['bookmarks', a, channel] as const,
  emoji: (a: string) => ['emoji', a] as const,
  usergroups: (a: string) => ['usergroups', a] as const,
  dnd: (a: string) => ['dnd', a] as const,
  presence: (a: string, user: string) => ['presence', a, user] as const,
  reminders: (a: string) => ['reminders', a] as const,
  scheduled: (a: string) => ['scheduled', a] as const,
  search: (a: string, q: string) => ['search', a, q] as const,
  files: (a: string, filter: string) => ['files', a, filter] as const,
  file: (a: string, url: string) => ['file', a, url] as const,
  permalink: (a: string, channel: string, ts: string) => ['permalink', a, channel, ts] as const,
}
